module.exports = Object.freeze({
    SITE_URL: "http://www.minibean.com.hk/",
    API_URL: "http://ec2-54-169-166-235.ap-southeast-1.compute.amazonaws.com:9000/"
});



// WEBPACK FOOTER //
// ./src/config_dev.js